import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getCategories } from '../services/api';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const tabs = [
  { key: 'route', label: 'ROTALAR' },
  { key: 'collection', label: 'KOLEKSİYONLAR' },
];

// Fallback images per category type if a category has no image set
const fallbackImage = {
  route: 'https://images.unsplash.com/photo-1464207687429-7505649dae38?w=800&q=80',
  collection: 'https://images.unsplash.com/photo-1551632811-561732d1e306?w=800&q=80',
};

const ExploreSection = () => {
  const [activeTab, setActiveTab] = useState('route');
  const [allCategories, setAllCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const scrollRef = useRef(null);

  useEffect(() => {
    getCategories()
      .then((res) => setAllCategories(res.data || []))
      .catch((e) => console.error('Categories fetch error:', e))
      .finally(() => setLoading(false));
  }, []);

  const items = allCategories.filter((c) => c.type === activeTab);

  const scroll = (dir) => {
    if (scrollRef.current) {
      const amount = dir === 'left' ? -320 : 320;
      scrollRef.current.scrollBy({ left: amount, behavior: 'smooth' });
    }
  };

  if (loading) return <div className="py-12 text-center text-gray-500">Yükleniyor...</div>;

  return (
    <section className="py-12 md:py-16 bg-white" id="explore">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        {/* Tabs */}
        <div className="flex items-center gap-8 mb-8 border-b border-gray-200">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => {
                setActiveTab(tab.key);
                if (scrollRef.current) scrollRef.current.scrollLeft = 0;
              }}
              data-testid={`explore-tab-${tab.key}`}
              className={`pb-3 text-[13px] font-semibold tracking-[0.08em] transition-colors relative ${
                activeTab === tab.key
                  ? 'text-[#1B1B1B]'
                  : 'text-gray-400 hover:text-gray-600'
              }`}
              style={{ fontFamily: 'DM Sans, sans-serif' }}
            >
              {tab.label}
              {activeTab === tab.key && (
                <span className="absolute bottom-0 left-0 right-0 h-[3px] bg-[#C8D843] rounded-t-full" />
              )}
            </button>
          ))}
        </div>

        {items.length === 0 && (
          <p className="text-sm text-gray-500 py-8">
            Henüz {activeTab === 'route' ? 'rota' : 'koleksiyon'} eklenmedi.
          </p>
        )}

        {/* Cards Container */}
        <div className="relative group">
          <button
            onClick={() => scroll('left')}
            className="absolute -left-4 top-1/2 -translate-y-1/2 z-20 bg-white shadow-lg rounded-full p-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 hover:bg-gray-50"
            aria-label="Kaydır"
          >
            <ChevronLeft size={20} />
          </button>

          <div
            ref={scrollRef}
            className="flex gap-5 overflow-x-auto scroll-smooth pb-4"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {items.map((item) => (
              <Link
                key={item.id}
                to={`/turlar?category=${item.id}`}
                data-testid={`explore-card-${item.id}`}
                className="group/card flex-shrink-0 w-[260px] md:w-[300px] cursor-pointer"
              >
                <div className="relative w-full aspect-[4/3] rounded-xl overflow-hidden mb-3">
                  <img
                    src={item.image || fallbackImage[item.type]}
                    alt={item.name}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover/card:scale-110"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-5">
                    <h3
                      className="text-white font-bold text-xl mb-1"
                      style={{ fontFamily: 'DM Sans, sans-serif' }}
                    >
                      {item.name}
                    </h3>
                    <p className="text-white/80 text-sm">{item.count || 0} tur</p>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <button
            onClick={() => scroll('right')}
            className="absolute -right-4 top-1/2 -translate-y-1/2 z-20 bg-white shadow-lg rounded-full p-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 hover:bg-gray-50"
            aria-label="Kaydır"
          >
            <ChevronRight size={20} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default ExploreSection;
